import React from 'react';
import { Mail, Smartphone, MessageCircle } from 'lucide-react';

type ChannelKey = 'in_platform' | 'email' | 'sms';

interface ChannelSelectorProps {
  selected?: ChannelKey;
  onSelect?: (channel: ChannelKey) => void;
}

const options: { key: ChannelKey; Icon: React.ComponentType<any>; label: string }[] = [
  { key: 'in_platform', Icon: MessageCircle, label: 'In‑platform' },
  { key: 'email', Icon: Mail, label: 'Email' },
  { key: 'sms', Icon: Smartphone, label: 'SMS' },
];

export default function ChannelSelector({ selected = 'in_platform', onSelect }: ChannelSelectorProps) {
  return (
    <div className="flex space-x-4">
      {options.map(({ key, Icon, label }) => {
        const isSelected = key === selected;
        return (
          <button
            key={key}
            onClick={() => onSelect && onSelect(key)}
            className={`p-2 rounded ${
              isSelected
                ? 'bg-primary/20 text-primary'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
            }`}
            title={label}
          >
            <Icon size={20} />
          </button>
        );
      })}
    </div>
  );
}